import React from "react";
import { motion } from "framer-motion";
import { FaGem, FaUserTie, FaHandHoldingHeart, FaCrown } from "react-icons/fa";
import "./whychoose.css";

function WhyChooseUs() {
  const reasons = [
    {
      icon: <FaGem />,
      title: "Premium Quality",
      desc: "Every collection is crafted with top-notch fabrics and intricate detailing.",
    },
    {
      icon: <FaUserTie />,
      title: "Expert Designers",
      desc: "Our designs are created by seasoned professionals in wedding fashion.",
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Personalized Service",
      desc: "We ensure every bride & groom finds the attire that matches their dream.",
    },
    {
      icon: <FaCrown />,
      title: "Royal Elegance",
      desc: "Traditional with a modern touch, making you stand out on your big day.",
    },
  ];

  return (
    <section className="why-choose-us" id="whychooseus">
      <h2>WHY CHOOSE US ?</h2>
      <div className="reasons-grid">
        {reasons.map((item, index) => (
          <motion.div
            className="reason-card"
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.6 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default WhyChooseUs;
